import { Flex } from '@web/components/atoms/Layout'
import type { Column as ColumnProps } from '@web/graphql-components'
import { useColorWithOpacity } from '@web/components/molecules/ColorPicker/utils'
import { ComponentWrapper, PageComponentProps } from '../utils'
import { useMediaQuery } from '@web/components/utils/chakra-hooks'
import { PropsWithChildren } from 'react'

type Props = ColumnProps & PageComponentProps & ComponentWrapper

export const ColumnInner = (props: PropsWithChildren<Props>) => {
  const styles = props.styles ?? {}
  const backgroundColor = useColorWithOpacity(props.styles?.backgroundColor, '1')

  return (
    <Flex
      flexDirection="column"
      h="100%"
      position="relative"
      css={{
        display: 'contents',
        '@media (min-width: 901px)': {
          display: 'flex',
          padding: styles?.padding ?? '16px',
          alignItems: styles?.alignItems ?? 'center',
          justifyContent: styles?.justifyContent ?? 'start',
          aspectRatio: styles?.aspectRatio,
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            opacity: styles?.opacity ?? 0,
            ...(styles?.backgroundImage
              ? {
                  backgroundImage: `url('${styles?.backgroundImage}')`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: styles?.backgroundPosition ?? '50% 50%',
                  backgroundSize: 'cover',
                }
              : {
                  backgroundColor,
                }),
          },
        },
      }}
      w="100%"
    >
      {props.children}
    </Flex>
  )
}

const Column = (props: Props) => {
  const { childComponents, allComponents, Component } = props
  const [isMobile] = useMediaQuery(['(max-width: 900px)'], { fallback: [] })

  if (isMobile) {
    return childComponents?.map((c) => <Component key={c.id} {...c} allComponents={allComponents} />)
  }

  return (
    <ColumnInner {...props}>
      {childComponents?.map((c) => (
        <Component key={c.id} {...c} allComponents={allComponents} />
      ))}
    </ColumnInner>
  )
}

export default Column
